import React, { useContext, useEffect, useRef } from 'react'
import axios from 'axios'
import ENDPOINT from '../../context/EndPoint'
import SecurityHeaders from '../../context/SecurityHeaders'
import { useState } from 'react'
import { Modal,Table} from 'react-bootstrap';
import { Delete } from '@material-ui/icons';
import DeleteModal from '../../components/modals/DeleteModal'
import { Link } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import ReviewVideoItem from './ReviewVideoItem'
import { useDispatch } from 'react-redux'
import { useActionsContext } from '../../context/ActionsContext'

const ReviewVideos = () => {
  const dispatch = useDispatch()
      const { user } = useContext(AuthContext);
          const { rowsPerPage, setRowsPerPage } = useActionsContext(); 
      
    
    const [videos, setVideos] = useState([])
 
 

  const getVideos = async () => {
    dispatch({type:'LOADING'})
    const data = new FormData()
    data.append('session', user.SessionId)
    data.append('limit', rowsPerPage)
    try {
      const response = await axios.post(`${ENDPOINT}admin-get-review-videos.php`, data, SecurityHeaders)
      if (response.data.status === 'success') {
        setVideos(response.data.data)
        dispatch({type:'DONE_LOADING'})
      }
    } catch (error) {
      console.error(error)
      dispatch({type:'ERROR',payload:error.message})
    }
  }


    useEffect(() => {
        getVideos()
      }, [rowsPerPage])

  return (
    <>
     <div className="container-fluid pt-4">
     
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Gallery Images</h2>
          <Link className='btn btn-primary' to="/add-review-video" variant="primary" >
            Add New Video
          </Link>
        </div>

        <div className="table-responsive">
          <Table bordered hover>
            <thead>
              <tr>
              
                <th>Image</th>
                <th>video</th>
                <th>Category</th>
             
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {videos && videos.length > 0 ? (
                videos.map((image,index) => (
               <ReviewVideoItem image={image} reload={getVideos}  index={index}/>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center empty-message">
                    No images found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      
    </>
  )
}

export default ReviewVideos

